import { createSlice } from '@reduxjs/toolkit';

export enum RecordFilterType {
  MyRecords = 'myRecords',
  MyTeamsRecords = 'myTeamsRecords',
  AllRecords = 'allRecords',
}

export type RecordFilterStateProps = {
  filterType: RecordFilterType;
  selectedTeams: string[];
};

const initialState: RecordFilterStateProps = {
  filterType: RecordFilterType.AllRecords,
  selectedTeams: [],
};

const recordFilter = createSlice({
  name: 'recordFilter',
  initialState,
  reducers: {
    setFilterType(state, action: { payload: RecordFilterType }) {
      state.filterType = action.payload;
    },
    setSelectedTeams(state, action: { payload: string[] }) {
      state.selectedTeams = action.payload;
    },
    setFilterState(
      state,
      action: { payload: Partial<RecordFilterStateProps> }
    ) {
      if (action.payload.filterType !== undefined) {
        state.filterType = action.payload.filterType;
      }
      if (action.payload.selectedTeams !== undefined) {
        state.selectedTeams = action.payload.selectedTeams;
      }
    },
  },
});

export default recordFilter.reducer;

export const { setFilterType, setSelectedTeams, setFilterState } =
  recordFilter.actions;
